import * as x from '../helpers/xmlHelpers';

export class PropertyGroundRent {
    constructor(doc)
    {
		this.label = null
		this.propertyGroundLeaseAnnualAmount = null;
		this.propertyGroundLeaseExpirationDate = null
		this.propertyGroundLeaseRenewableIndicator = null
		this.propertyGroundLeaseTermYearsCount = null
		this.propertyGroundRentDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.propertyGroundLeaseAnnualAmount  = x.getMISMOAmountElement(doc, "./ns:PropertyGroundLeaseAnnualAmount");
		this.propertyGroundLeaseExpirationDate = x.getMISMODateElement(doc, "./ns:PropertyGroundLeaseExpirationDate");
		this.propertyGroundLeaseRenewableIndicator = x.getBooleanElement(doc, "./PropertyGroundLeaseRenewableIndicator");
		this.propertyGroundLeaseTermYearsCount = x.getIntegerElement(doc, "./ns:PropertyGroundLeaseTermYearsCount");
		this.propertyGroundRentDescription = x.getStringElement(doc, "./ns:PropertyGroundRentDescription");
   }
}

